// extracted by mini-css-extract-plugin
module.exports = {"galleryItem":"Gallery__galleryItem__gsKB5"};